export const toTitleCase = (str) => {
  const lowerWords = [
    'a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'from', 'in', 'of', 'on', 'or', 'so', 'the', 'to', 'up', 'with'
  ]
  if (!str) return ''
  return str
    .toLowerCase()
    .split(' ')
    .map((word, idx, arr) => {
      if (
        lowerWords.includes(word) &&
        idx !== 0 &&
        idx !== arr.length - 1
      ) {
        return word
      }
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')
}
